export default "__VITE_PUBLIC_ASSET__f0f44246__"